const ATTEMPTED_QUIZ_CACHE_KEY = "attempted_quiz_map_v1";

const readAttemptMap = () => {
  try {
    const raw = window.localStorage.getItem(ATTEMPTED_QUIZ_CACHE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

const writeAttemptMap = (mapValue) => {
  try {
    window.localStorage.setItem(ATTEMPTED_QUIZ_CACHE_KEY, JSON.stringify(mapValue));
  } catch {
    // Ignore storage write failures.
  }
};

const normalizeOwnerId = (userId) => String(userId ?? "").trim();

export const makeTopicQuizAttemptKey = ({ subject, topic, slug, id }) =>
  `topic::${String(subject || "").trim().toLowerCase()}::${String(topic || "")
    .trim()
    .toLowerCase()}::${String(slug || "").trim().toLowerCase()}::${String(id || "")
    .trim()
    .toLowerCase()}`;

export const makeCurrentAffairsAttemptKey = (slugWithId) =>
  `ca::${String(slugWithId || "").trim().toLowerCase()}`;

export const getQuizAttemptSummary = (attemptKey, userId) => {
  if (!attemptKey || typeof window === "undefined") return null;
  const mapValue = readAttemptMap();
  const attempt = mapValue[attemptKey];
  if (!attempt || typeof attempt !== "object") return null;

  const requestedOwner = normalizeOwnerId(userId);
  const storedOwner = normalizeOwnerId(attempt.userId);
  if (requestedOwner && storedOwner && requestedOwner !== storedOwner) {
    return null;
  }

  return attempt;
};

export const isQuizAttempted = (attemptKey, userId) => {
  if (!attemptKey || typeof window === "undefined") return false;
  return Boolean(getQuizAttemptSummary(attemptKey, userId));
};

export const markQuizAttempted = (attemptKey, metadata = {}) => {
  if (!attemptKey || typeof window === "undefined") return;
  const mapValue = readAttemptMap();
  const currentValue =
    mapValue[attemptKey] && typeof mapValue[attemptKey] === "object" ? mapValue[attemptKey] : {};
  mapValue[attemptKey] = {
    ...currentValue,
    ...metadata,
    attemptedAt: new Date().toISOString(),
  };
  writeAttemptMap(mapValue);
};

export const listQuizAttemptsForUser = (userId) => {
  if (typeof window === "undefined") return [];

  const requestedOwner = normalizeOwnerId(userId);
  return Object.entries(readAttemptMap())
    .filter(([, attempt]) => attempt && typeof attempt === "object")
    .filter(([, attempt]) => {
      const storedOwner = normalizeOwnerId(attempt.userId);
      if (!requestedOwner) return true;
      if (!storedOwner) return true;
      return storedOwner === requestedOwner;
    })
    .map(([attemptKey, attempt]) => ({
      attemptKey,
      ...attempt,
    }))
    .sort((left, right) => {
      const rightTime = new Date(right.submittedAt || right.attemptedAt || 0).getTime() || 0;
      const leftTime = new Date(left.submittedAt || left.attemptedAt || 0).getTime() || 0;
      return rightTime - leftTime;
    });
};
